namespace Areas.Building.Profile {
    "use strict";

    var imageUrls;  

    $(() => {
        var tile = $("#tileView").dxTileView("instance");

        if (tile) {
            var buildingId = $("#BuildingForm").dxForm("instance").option("KeyId");
            $.get(`/Building/Profile/GetImageUrls/${buildingId}`, (data) => {
                imageUrls = data;
                tile.option("dataSource", imageUrls);
            });
        }
    });

    export function itemTemplate(itemData: any, itemIndex: any, itemElement:any) {
        var style = `cursor:pointer;height:100%;width:100%;display:block;background-size:cover;background-position:center;background-image: url('${itemData.url}')`;
        itemElement.append(`<div class=\"thumbnail\" style=\"${style}\"></div>`);
    }

    export function lookupLEEDTypeTemplate(itemData: any, itemIndex: any, itemElement: any) {
        return Areas.lookupActiveTemplate((i) => i.leedTypeLk)(itemData, itemIndex, itemElement);
    }

    export function onItemClick(e: any) {
        const imageGalleryDialog = new Areas.Dialog.ImageGalleryDialog(dialogClosing, imageUrls, extraInitialization);
    }

    function extraInitialization() {
        const gallery = $("#gallery").dxGallery("instance");
        gallery.option("dataSource", this.parameters.map(i => i.url));
        gallery.repaint();
    }

    export function updateBuilding() {
        const form = $("#BuildingForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/Building/Profile/Put/${keyId}`, JSON.stringify(newData), "PUT");
        }
    }    

    export function showGpsDialog() {
        const form = $("#BuildingForm").dxForm("instance");
        const formData: any = form.option("formData");        
        const dialogGps = new Dialogs.GpsDialog(updateBuildingGps, formData.GPS);       
    }

    function updateBuildingGps(dialogResult: DialogResult, data: any) {
        
        if (dialogResult === DialogResult.Cancel) return;

        const form = $("#BuildingForm").dxForm("instance");
        const formData: any = form.option("formData");

        if (data) {
            formData.GPS = data;
            form.option("formData", formData);    
        }
    }

    export function goToSpaceInventory() {
        const form = $("#BuildingForm").dxForm("instance");
        const formData: any = form.option("formData");

        if (formData) {
            var id = formData.LocationId;
            let linkInfo = "http://spaceinventory.ucla.edu/#/LocID/" + id;
            window.open(linkInfo);
        }
    }

    function dialogClosing(dialogResult: DialogResult, data: any) {
    }  

    export function selectBox_valueChanged(e: any)
    {
        if (e.value = 1) {
            Areas.goToEdit()
        }
        if (e.value = 2) {
            Areas.goToView()
        }
        if (e.value = 3) {
            Areas.goToEdit()
        }
    }
}
